import { render, staticRenderFns } from "./dialog-setexpiredfile.vue?vue&type=template&id=6f185424&"
import script from "./dialog-setexpiredfile.vue?vue&type=script&lang=js&"
export * from "./dialog-setexpiredfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports